import { BaseModel } from './BaseModel';

export class UserRole extends BaseModel {
  static LEARNER = 'learner';
  static TEACHER = 'teacher';
  static DESIGNER = 'designer';
  static LU_OWNER = 'lu_owner';
  static LU_INSTRUCTOR = 'lu_instructor';
  static LU_ASSESSOR = 'lu_assessor';

  static get entity() {
    return 'user-roles';
  }

  static get fk() {
    return 'user_role_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      role: this.string(''),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    };
  }

  static role(role = '') {
    return this.query().where('role', role).first();
  }

  static learner() {
    return this.query().where('role', this.LEARNER).first();
  }

  static teacher() {
    return this.query().where('role', this.TEACHER).first();
  }

  static learningUnitOwner() {
    return this.query().where('role', this.LU_OWNER).first();
  }

  static learningUnitInstructor() {
    return this.query().where('role', this.LU_INSTRUCTOR).first();
  }

  static learningUnitAssessor() {
    return this.query().where('role', this.LU_ASSESSOR).first();
  }

  static apiConfig = {
    actions: {
      async fetch() {
        return this.get(`/user-roles`);
      },
      async fetchById(id) {
        return this.get(`/user-roles/${id}`);
      }
    }
  };
}

export default UserRole;
